import {DataTableColumn} from "mantine-datatable";
import {MeteringRecord} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {formatTimestamp, TIMESTAMP_PLACEHOLDER} from "../../../utils/TableTimestamps.tsx";

// Every column is sortable (§3a). The `accessor` is what sorts: `value` sorts on the
// raw number and the timestamps sort as ISO-8601, not on the formatted text.
//
// No `created` column: the default sort is created DESC (useMeteringRecords, the API's
// own order) without showing it, matching payment-events. Any header click re-sorts.
export const useMeteringRecordsTableColumns = () => {

    const columns: DataTableColumn<MeteringRecord>[] = [
        {
            accessor: 'customerId',
            title: I18n.get('Customer'),
            sortable: true,
            width: '1fr',
            render: (item: MeteringRecord) => item.customerId,
        },
        {
            accessor: 'meterCode',
            title: I18n.get('Meter'),
            sortable: true,
            width: '1fr',
            render: (item: MeteringRecord) => item.meterCode ?? TIMESTAMP_PLACEHOLDER,
        },
        {
            accessor: 'periodStart',
            title: I18n.get('Period Start'),
            sortable: true,
            width: '1fr',
            render: (item: MeteringRecord) => formatTimestamp(item.periodStart),
        },
        {
            accessor: 'periodEnd',
            title: I18n.get('Period End'),
            sortable: true,
            width: '1fr',
            render: (item: MeteringRecord) => formatTimestamp(item.periodEnd),
        },
        {
            accessor: 'value',
            title: I18n.get('Value'),
            sortable: true,
            width: '1fr',
            render: (item: MeteringRecord) => typeof item.value === 'number' ? String(item.value) : TIMESTAMP_PLACEHOLDER,
        },
        {
            accessor: 'state',
            title: I18n.get('State'),
            sortable: true,
            width: '1fr',
            render: (item: MeteringRecord) => <StatusBadge status={item.state}/>,
        },
        {
            accessor: 'updated',
            title: I18n.get('Updated'),
            sortable: true,
            width: '1fr',
            render: (item: MeteringRecord) => formatTimestamp(item.updated),
        },
    ];

    return {
        columns,
    }
}
